import { BaseApi } from "../../utils/BaseApi";
import { HttpMethodEnum } from "../models/HttpMethodEnum";
import {
  StayProperty,
  StaysCategory,
  StaysConfig,
  StaysReservationRequest,
  StaysReservationStatus,
} from "../models/Experience/ExperienceModels";
import { StoreDomain } from "../models/Experience/ExperienceSharedModels";

class StaysApi extends BaseApi {
  public config = BaseApi.createEndpoint<StaysConfig, null>(HttpMethodEnum.GET, "/stays/config");
  public updateConfig = BaseApi.createEndpoint<StaysConfig, { config: Partial<StaysConfig> }>(
    HttpMethodEnum.PUT,
    "/stays/config",
  );
  public publish = BaseApi.createEndpoint<StaysConfig, { config: Partial<StaysConfig> }>(
    HttpMethodEnum.POST,
    "/stays/publish",
  );
  public categories = BaseApi.createEndpoint<StaysCategory[], null>(HttpMethodEnum.GET, "/stays/categories");
  public createCategory = BaseApi.createEndpoint<StaysCategory, { category: Partial<StaysCategory> }>(
    HttpMethodEnum.POST,
    "/stays/categories",
  );
  public updateCategory = (id: string) =>
    BaseApi.createEndpoint<StaysCategory, { category: Partial<StaysCategory> }>(
      HttpMethodEnum.PUT,
      `/stays/categories/${id}`,
    );
  public deleteCategory = (id: string) =>
    BaseApi.createEndpoint<boolean, null>(HttpMethodEnum.DELETE, `/stays/categories/${id}`);
  public properties = BaseApi.createEndpoint<StayProperty[], null>(HttpMethodEnum.GET, "/stays/properties");
  public createProperty = BaseApi.createEndpoint<StayProperty, { property: Partial<StayProperty> }>(
    HttpMethodEnum.POST,
    "/stays/properties",
  );
  public updateProperty = (id: string) =>
    BaseApi.createEndpoint<StayProperty, { property: Partial<StayProperty> }>(
      HttpMethodEnum.PUT,
      `/stays/properties/${id}`,
    );
  public deleteProperty = (id: string) =>
    BaseApi.createEndpoint<boolean, null>(HttpMethodEnum.DELETE, `/stays/properties/${id}`);
  public domains = BaseApi.createEndpoint<StoreDomain[], null>(HttpMethodEnum.GET, "/stays/domains");
  public addDomain = BaseApi.createEndpoint<StoreDomain, { hostname: string }>(
    HttpMethodEnum.POST,
    "/stays/domains",
  );
  public verifyDomain = (hostname: string) =>
    BaseApi.createEndpoint<StoreDomain, null>(
      HttpMethodEnum.POST,
      `/stays/domains/${encodeURIComponent(hostname)}/verify`,
    );
  public reservations = BaseApi.createEndpoint<StaysReservationRequest[], null>(
    HttpMethodEnum.GET,
    "/stays/reservations",
  );
  public updateReservationStatus = (reservationId: string) =>
    BaseApi.createEndpoint<StaysReservationRequest, { status: StaysReservationStatus }>(
      HttpMethodEnum.PUT,
      `/stays/reservations/${reservationId}/status`,
    );
}

export const staysApi = new StaysApi();
